<template>
  <div class="container">
    <div class="l1">
      <div class="title">
        <span>监控设备</span>
        有{{ pcList.length }}台设备
      </div>
      <div class="data-box">
        <div class="data-info d-cen1">
          <div
            class="data-item"
            v-for="item in pcList"
            :key="item"
            @click="handleshowPcinfo(item)"
          >
            <div
              :class="
                item.pcStatus == 1
                  ? 'data-item-i data-item-i1'
                  : 'data-item-i data-item-i2'
              "
              v-if="item.status == 0"
            >
              <div class="status status1 d-cen2">正常</div>
              <div class="data-item-m">
                <div class="t1">{{ item.liveName || "-" }}</div>
                <div class="t-list d-cen-sb" v-if="item.pcUseInfo">
                  <div class="t-list-item">
                    <div class="t-value">{{ item.pcUseInfo.pcCpu }}%</div>
                    <div class="t-text">CPU占用</div>
                  </div>
                  <div class="t-list-item">
                    <div class="t-value">{{ item.pcUseInfo.pcMemory }}%</div>
                    <div class="t-text">内存占用</div>
                  </div>
                  <div class="t-list-item">
                    <div
                      class="t-value t-value-t"
                      style="color: #1677ff !important"
                      v-if="item.pcUseInfo.liveProcess == 1"
                    >
                      已开启
                    </div>
                    <div
                      class="t-value t-value-t"
                      style="color: #8491af !important"
                      v-else
                    >
                      未开启
                    </div>
                    <div class="t-text">直播伴侣</div>
                  </div>
                </div>
              </div>
              <div class="startupTime">
                自动关机时间：{{ item.shutdownTime || "未设置" }}
              </div>
            </div>
            <div class="data-item-i data-item-i3" v-if="item.status == 1">
              <div class="status status2 d-cen2">离线中</div>
              <div class="data-item-m">
                <div class="t1">{{ item.liveName || "-" }}</div>
                <div class="t-list d-cen-sb">
                  <div class="t-list-item">
                    <div class="t-value">0%</div>
                    <div class="t-text">CPU占用</div>
                  </div>
                  <div class="t-list-item">
                    <div class="t-value">0%</div>
                    <div class="t-text">内存占用</div>
                  </div>
                  <div class="t-list-item">
                    <div class="t-value t-value-t">未开启</div>
                    <div class="t-text">直播伴侣</div>
                  </div>
                </div>
              </div>
              <div class="startupTime">
                自动关机时间：{{ item.shutdownTime || "未设置" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="m-b m-b1" v-if="pcUseInfoShow">
      <div class="m-main">
        <div class="m-head">
          <div class="title">{{ pcUseDetail.liveName }}设备使用情况</div>
          <el-icon class="CloseBold" @click="handleCloase"
            ><CloseBold
          /></el-icon>
        </div>
        <div height="" style="background: #fff; height: 82vh">
          <div class="card1-1">
            <div class="d-cen-sb">
              <div class="card-title">监控设备</div>
            </div>
            <div class="pcstatus pcstatus1" v-if="pcUseDetail.pcStatus == 1">
              <div class="status status1">运行中</div>
              <div class="data-item-m data-item-m1">
                <div class="t1">{{ pcUseDetail.liveName || "-" }}</div>
                <div class="t-list d-cen-sb">
                  <div class="t-list-item">
                    <div class="t-text">CPU占用</div>
                    <div class="t-value">
                      {{ pcUseDetail.pcUseInfo.pcCpu || 0 }}%
                    </div>
                  </div>
                  <div class="t-list-item">
                    <div class="t-text">内存占用</div>
                    <div class="t-value">
                      {{ pcUseDetail.pcUseInfo.pcMemory || 0 }}%
                    </div>
                  </div>
                  <div class="t-list-item">
                    <div class="t-text">直播伴侣</div>
                    <div
                      class="t-value t-value2"
                      v-if="pcUseDetail.pcUseInfo.liveProcess == 1"
                    >
                      已开启
                    </div>
                    <div class="t-value t-value1" v-else>未开启</div>
                  </div>
                </div>
              </div>
              <div class="startupTime">
                <!-- 自动关机时间：{{ pcUseDetail.shutdownTime || "未设置" }} -->
                <div class="d-cen1">
                  <div>
                    自动关机时间：{{ pcUseDetail.shutdownTime || "未设置" }}
                  </div>
                  <!-- <div class="reset-btn" @click="handleResetTime">重新设置</div> -->
                </div>
              </div>
            </div>
            <div class="pcstatus pcstatus2" v-if="pcUseDetail.pcStatus == 2">
              <div class="status status1">运行中</div>

              <!-- <div class="status status2">离线中</div> -->
              <div class="data-item-m data-item-m2">
                <div class="t1">{{ pcUseDetail.liveName || "-" }}</div>
                <div class="t-list d-cen-sb">
                  <div class="t-list-item">
                    <div class="t-text">CPU占用</div>
                    <div class="t-value">
                      {{ pcUseDetail.pcUseInfo.pcCpu || 0 }}%
                    </div>
                  </div>
                  <div class="t-list-item">
                    <div class="t-text">内存占用</div>
                    <div class="t-value">
                      {{ pcUseDetail.pcUseInfo.pcMemory || 0 }}%
                    </div>
                  </div>
                  <div class="t-list-item">
                    <div class="t-text">直播伴侣</div>
                    <div
                      class="t-value t-value2"
                      v-if="pcUseDetail.pcUseInfo.liveProcess == 1"
                    >
                      已开启
                    </div>
                    <div class="t-value t-value1" v-else>未开启</div>
                  </div>
                </div>
              </div>
              <div class="startupTime">
                <div class="d-cen1">
                  <div>
                    自动关机时间：{{ pcUseDetail.shutdownTime || "未设置" }}
                  </div>
                  <!-- <div class="reset-btn d-cen2" @click="handleResetTime">
                    重新设置
                  </div> -->
                </div>
              </div>
            </div>
            <div class="pcstatus pcstatus3" v-if="pcUseDetail.pcStatus == 3">
              <div class="status status2">离线中</div>
              <div class="data-item-m data-item-m3">
                <div class="t1">{{ pcUseDetail.liveName || "-" }}</div>
                <div class="t-list d-cen-sb">
                  <div class="t-list-item">
                    <div class="t-text">CPU占用</div>
                    <div class="t-value">0%</div>
                  </div>
                  <div class="t-list-item">
                    <div class="t-text">内存占用</div>
                    <div class="t-value">0%</div>
                  </div>
                  <div class="t-list-item">
                    <div class="t-text">直播伴侣</div>
                    <div class="t-value t-value1">未开启</div>
                  </div>
                </div>
              </div>
              <div class="startupTime">
                自动关机时间：{{ pcUseDetail.shutdownTime || "未设置" }}
              </div>
            </div>
          </div>
          <div class="card1-1 card1-2">
            <div class="d-cen-sb">
              <div class="card-title">CPU使用率趋势图</div>
              <div>
                <el-date-picker
                  :clearable="false"
                  @change="changeTime"
                  value-format="YYYY-MM-DD"
                  v-model="queryTime"
                  type="date"
                  size="small"
                  placeholder="自定义时间"
                />
              </div>
            </div>
            <div
              class="chart-box"
              style="width: 100%; height: calc(96vh - 450px)"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <el-dialog
      v-model="centerDialogVisible"
      title="设置自动关机"
      width="400px"
      left
    >
      <div class="d-cen2">
        <div>
          每天
          <el-time-picker
            size="mini"
            value-format="HH:mm:ss"
            style="width: 110px"
            v-model="shutdownTime"
            placeholder="请选择"
          />
          自动关机
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer d-cen2">
          <el-button
            style="width: 120px"
            size="small"
            type="primary"
            round
            :loading="shutdownTimeLogin"
            @click="handleSureTime"
          >
            保 <span style="margin: 0 10px"></span> 存
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { ElMessage } from "element-plus";
import { ref, reactive, onMounted, onUnmounted, nextTick } from "vue";
import apiData from "@/api/apiData.js";
import * as echarts from "echarts";
const pcList = ref([]);
// const interTime = 3000;
const interTime = 60000;
// const interTime = 600000;

const queryTime = ref(new Date().toISOString().split("T")[0]); // 设置默认值为今天

const pcUseDetail = ref({
  status: 1,
});
const getDataList = () => {
  apiData.pcBaseList().then((res) => {
    if (res.code == 200) {
      pcList.value = res.data;
      pcList.value.forEach((item) => {
        if (item.status == 0) {
          const pcCpu = parseFloat(item.pcUseInfo.pcCpu);
          if (pcCpu >= 0 && pcCpu < 80) {
            item.pcStatus = 1;
          } else if (pcCpu >= 80 && pcCpu <= 100) {
            item.pcStatus = 2;
          }
        }
      });
    }
  });
};
const handlePageChange = (newPage) => {
  pageNum.value = newPage;
  getdyDataPage();
};
const handleCloase = () => {
  pcUseInfoShow.value = false;
  // 清除定时器
  clearInterval(intervalId1);
  clearInterval(intervalId2);
  getDataList();
  intervalId = setInterval(() => getDataList, interTime);
};
const pcId = ref("");
const pcUseInfoShow = ref(false);
const handleshowPcinfo = (item) => {
  pcUseInfoShow.value = true;
  pcId.value = item.id;
  queryTime.value = new Date().toISOString().split("T")[0];
  getpcUserInfo(pcId.value);
  getpcBaseDetail(pcId.value);
  // 使用 nextTick 确保 DOM 更新后再初始化图表
  nextTick(() => {
    initChart();
    intervalId1 = setInterval(() => getpcUserInfo(pcId.value), interTime); // 每隔10秒请求一次接口
    intervalId2 = setInterval(() => getpcBaseDetail(pcId.value), interTime); // 每隔10分钟请求一次接口
  });
};
const changeTime = (value) => {
  // 清除现有的 intervalId1 定时器
  clearInterval(intervalId1);
  getpcUserInfo(pcId.value);
  // 重新设置 intervalId1 定时器
  intervalId1 = setInterval(() => getpcUserInfo(pcId.value), interTime); // 每隔10分钟请求一次接口
};
const centerDialogVisible = ref(false);
const shutdownTime = ref("");
const handleResetTime = (value) => {
  console.log(pcUseDetail.value);
  centerDialogVisible.value = true;
  shutdownTimeLogin.value = false;
  shutdownTime.value = pcUseDetail.value.shutdownTime;

  // apiData.resetTime({ id: pcId.value }).then((res) => {
  //   if (res.code == 200) {
  //     getpcBaseDetail(pcId.value);
  //   }
  // });
};
const shutdownTimeLogin = ref(false);
const handleSureTime = () => {
  console.log("重置");
  if (!shutdownTime.value) {
    return ElMessage({
      message: "请选择自动关机时间",
      type: "error",
    });
  }
  shutdownTimeLogin.value = true;
  apiData
    .updateShutdownTime({ id: pcId.value, shutdownTime: shutdownTime.value })
    .then((res) => {
      if (res.code == 200) {
        centerDialogVisible.value = false;
        shutdownTimeLogin.value = false;
        // 清除现有的 intervalId1 定时器
        clearInterval(intervalId2);
        clearInterval(intervalId);
        getpcBaseDetail(pcId.value);
        getDataList();
        // 重新设置 intervalId1 定时器
        intervalId2 = setInterval(() => getpcBaseDetail(pcId.value), interTime);
        intervalId = setInterval(() => getDataList, interTime);

        // getpcBaseDetail(pcId.value);
      }
    });
};

// 设备监控详情
const getpcBaseDetail = (id) => {
  apiData.getpcBaseDetailid({ id: id }).then((res) => {
    if (res.code == 200) {
      if (res.data.status == 0) {
        // res.data.pcUseInfo
        const pcCpu = parseFloat(res.data.pcUseInfo.pcCpu);
        if (pcCpu >= 0 && pcCpu < 80) {
          res.data.pcStatus = 1;
        } else if (pcCpu >= 80 && pcCpu <= 100) {
          res.data.pcStatus = 2;
        }
      } else {
        res.data.pcStatus = 3;
      }
      pcUseDetail.value = res.data;
      console.log(pcUseDetail.value);
    }
  });
};

let intervalId = null;
let intervalId1 = null;
let intervalId2 = null;
let chartInstance = null;
// 统计图
const cpuUsageHistory = ref([]);
const memoryUsageHistory = ref([]);
const getpcUserInfo = (id) => {
  apiData.getpcUserInfo({ id: id, queryTime: queryTime.value }).then((res) => {
    if (res.code == 200) {
      // console.log(JSON.stringify(res.data));
      if (res.code == 200) {
        const cpuUsageHistory = res.data.map((item) => ({
          time: item.time,
          cpu: parseFloat(item.pcCpu),
        }));
        const memoryUsageHistory = res.data.map((item) => ({
          time: item.time,
          memory: parseFloat(item.pcMemory),
        }));
        cpuUsageHistory.value = cpuUsageHistory;
        cpuUsageHistory.value = memoryUsageHistory;
        updateChart(cpuUsageHistory, memoryUsageHistory);
      }
    }
  });
};
const initChart = () => {
  const chartDom = document.querySelector(".chart-box");
  chartInstance = echarts.init(chartDom);
  const option = {
    // title: {
    //   text: "CPU 和 内存 使用率趋势图",
    // },
    tooltip: {
      trigger: "axis",
      formatter: function (params) {
        let tooltip = params[0].name + "<br/>";
        params.forEach((param) => {
          tooltip += `<span style="color: ${param.color}">${param.seriesName}: ${param.value}%</span><br/>`;
        });
        return tooltip;
      },
    },
    legend: {
      data: ["CPU 使用率", "内存使用率"],
    },
    xAxis: {
      type: "category",
      data: [],
    },
    yAxis: {
      type: "value",
      min: 0,
      max: 100,
      interval: 20,
      axisLabel: {
        formatter: "{value}%",
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: "dashed",
        },
      },
      axisLine: {
        show: true,
        lineStyle: {
          type: "solid",
        },
      },
    },
    series: [
      {
        name: "CPU 使用率",
        data: [],
        type: "line",
        itemStyle: {
          color: "#4595FE",
        },
      },
      {
        name: "内存使用率",
        data: [],
        type: "line",
        itemStyle: {
          color: "#31E56A",
        },
      },
    ],
    // 通过滑动来查看不同时间段的数据
    dataZoom: [
      {
        type: "slider", // 设置缩放组件的类型为滑动条
        show: true, // 显示缩放组件
        xAxisIndex: [0], // 表示这个缩放组件控制第一个 x 轴
        start: 0, // 数据窗口的起始百分比
        end: 30, // 数据窗口的结束百分比，这里设置为 10 表示默认只显示前 10% 的数据
      },
    ],
    grid: {
      left: "5%", // 减少左边距
      right: "5%", // 减少右边距
      top: "10%",
      bottom: "10%",
    },
  };
  chartInstance.setOption(option);
};
const resizeChart = () => {
  if (chartInstance) {
    chartInstance.resize();
  }
};

const updateChart = (cpuData, memoryData) => {
  if (chartInstance) {
    const xAxisData = cpuData.map((item) => item.time);
    const cpuSeriesData = cpuData.map((item) => item.cpu);
    const memorySeriesData = memoryData.map((item) => item.memory);
    chartInstance.setOption({
      xAxis: {
        data: xAxisData,
      },
      series: [
        {
          data: cpuSeriesData,
        },
        {
          data: memorySeriesData,
        },
      ],
    });
  }
};

onMounted(() => {
  getDataList();
  intervalId = setInterval(getDataList, interTime); // 每隔10分钟请求一次接口
  window.addEventListener("resize", resizeChart);
});
onUnmounted(() => {
  clearInterval(intervalId); // 组件卸载时清除定时器
  clearInterval(intervalId1); // 组件卸载时清除定时器
  clearInterval(intervalId2); // 组件卸载时清除定时器
  window.removeEventListener("resize", resizeChart);
});
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.container {
  font-family: PingFang SC, PingFang SC;
  // padding: 30px 35px;
  .l1 {
    padding: 22px 38px;
    background: #ffffff;
    border-radius: 18px 18px 18px 18px;
    min-height: calc(100vh - 120px);
    .title {
      font-weight: 500;
      font-size: 14px;
      color: #8491af;
      span {
        margin-right: 10px;
        font-weight: 500;
        font-size: 19px;
        color: #4595fe;
      }
    }
    .t-time {
      font-size: 13px;
      color: #999999;
    }

    .r-search {
      font-size: 13px;
      color: #999999;
      .time-item {
        border-radius: 11px 11px 11px 11px;
        border: 1px solid #c2cad8;
        font-size: 12px;
        color: #2d2d2d;
        padding: 3px 9px;
        border: 1px solid #c2cad8;
        display: inline-block;
        margin-left: 15px;
        cursor: pointer;
      }
      .time-active {
        background: #1677ff;
        border: 1px solid #1677ff;
        color: #fff;
      }
    }
    .example-pagination-block {
      margin: 30px 0;
    }
    .data-info {
      margin-top: 25px;
      flex-wrap: wrap;
      .data-item {
        width: 25%;
        cursor: pointer;

        padding: 10px;
        padding-right: 20px;
        padding-left: 0;
        position: relative;
        .data-status {
          position: absolute;

          border-radius: 0px 6px 0px 6px;
          right: 10px;
          top: 10px;
          font-size: 10px;
          padding: 2px 7px;
        }

        .data-item-i {
          //
          position: relative;
          box-shadow: 0px 0 7px 1px rgba(92, 92, 93, 0.1);
          border-radius: 7px 7px 7px 7px;
          padding: 17px 14px;
          .status {
            color: #fff;
            position: absolute;
            right: 0;
            top: 0;
            font-size: 11px;
            border-radius: 0px 11px 0px 11px;
            padding: 4px 14px;
          }
          .status1 {
            background: #4595fe;
          }
          .status2 {
            background: #8491af;
          }
        }
        .data-item-i1 {
          background: linear-gradient(46deg, #fdffff 0%, #e3eeff 100%);
        }
        .startupTime {
          font-size: 14px;
          color: #283e62;
        }
        .data-item-m {
          width: 100%;
          .t1 {
            font-weight: 500;
            font-size: 14px;
            color: #283e62;
          }
          .t-list {
            width: 100%;
            margin-top: 24px;
            margin-bottom: 22px;
          }
          .t-list-item {
            width: 33%;
            text-align: center;
            .t-value {
              font-weight: 500;
              font-size: 18px;
              color: #4595fe;
            }
            .t-value-t {
              font-size: 14px;
            }
            .t-text {
              font-weight: 500;
              font-size: 12px;
              color: #283e62;
            }
          }
        }

        .data-item-i1 {
        }
        .data-item-i3 {
          background: linear-gradient(46deg, #fdffff 0%, #e8e8e8 100%);
          box-shadow: 1px 2 7px 1px rgba(16, 101, 175, 0.15);
          .t-value {
            font-weight: 500;
            font-size: 17px;
            color: #8491af !important;
          }
        }
        .data-item-i2 {
          background: linear-gradient(46deg, #fdffff 0%, #ffe8e8 100%);
          box-shadow: 1px 2 7px 1px rgba(16, 101, 175, 0.15);
          .t-value {
            font-weight: 500;
            font-size: 17px;
            color: #de0d0d !important;
          }
        }
      }
    }
  }
}
.m-b1 {
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  height: 100vh;
  background: rgba(40, 62, 98, 0.35);
  padding: 20px;
  .m-main {
    width: 100%;
    height: 100%;
    height: 96vh;
    position: relative;
    background: #fff;
    border-radius: 12px;
    padding: 25px 38px;
    .card1-1 {
      width: 100%;
      background: #ffffff;
      box-shadow: 2px 2 8px 1px rgba(16, 101, 175, 0.15);
      // box-shadow: 0px 0 7px 1px rgba(92, 92, 93, 0.1);
      border-radius: 11px 11px 11px 11px;
      padding: 20px 30px;
      border: 1px solid #f6f6f6;

      margin-bottom: 20px;
      // padding-top: 0;
      .card-title {
        font-size: 19px;
        margin-bottom: 10px;
        color: #4595fe;
      }

      .pcstatus {
        background: #ffffff;
        width: 50%;
        width: 650px;
        box-shadow: 1px 2 7px 1px rgba(16, 101, 175, 0.15);
        border-radius: 11px 11px 11px 11px;
        border: 1px solid #f6f6f6;
        position: relative;
        padding: 18px 15px;
        .title1 {
          font-weight: 500;
          font-size: 14px;
          color: #283e62;
        }
        .status {
          color: #fff;
          position: absolute;
          right: 0;
          top: 0;
          font-size: 11px;
          border-radius: 0px 11px 0px 11px;
          padding: 4px 14px;
        }
        .status1 {
          background: #4595fe;
        }
        .status2 {
          background: #8491af;
        }
        titlet {
          font-weight: 500;
          font-size: 14px;
          color: #283e62;
        }
        .data-item-m {
          width: 100%;
          .t1 {
            font-weight: 500;
            font-size: 14px;
            color: #283e62;
          }
          .t-list {
            width: 100%;
            margin-top: 10px;
            margin-bottom: 15px;
          }
          .t-list-item {
            width: 33%;
            text-align: center;
            display: flex;
            align-items: center;
            .t-value {
              font-weight: 500;
              font-size: 30px;
              color: #4595fe;
              padding-left: 10px;
            }
            .t-value1 {
              font-size: 15px;
              color: #4595fe;
            }
            .t-value2 {
              font-size: 15px;
              color: #8491af;
            }
            .t-text {
              font-weight: 500;
              font-size: 15px;
              color: #283e62;
            }
          }

          .startupTime {
            font-size: 14px;
            color: #283e62;
          }
          .data-item-i3 {
            background: linear-gradient(46deg, #fdffff 0%, #e8e8e8 100%);
            box-shadow: 1px 2 7px 1px rgba(16, 101, 175, 0.15);
            .t-value {
              font-weight: 500;
              font-size: 17px;
              color: #8491af !important;
            }
          }
          .data-item-i2 {
            background: linear-gradient(46deg, #fdffff 0%, #ffe8e8 100%);
            box-shadow: 1px 2 7px 1px rgba(16, 101, 175, 0.15);
          }
        }
        .data-item-m1 {
          .t-value {
            color: #4595fe !important;
          }
          .t-value1 {
            color: #8491af !important;
          }
          .t-value2 {
            color: #4595fe !important;
          }
        }
        .data-item-m2 {
          .t-value {
            color: #de0d0d !important;
          }
          .t-value1 {
            color: #8491af !important;
          }
          .t-value2 {
            color: #4595fe !important;
          }
        }
        .data-item-m3 {
          .t-value {
            color: #8491af !important;
          }
          // .t-value1 {
          //   color: #4595fe !important;
          // }
        }
      }
      .pcstatus1 {
        background: linear-gradient(46deg, #fdffff 0%, #e3eeff 100%);
      }
      .pcstatus2 {
        background: linear-gradient(46deg, #fdffff 0%, #ffe8e8 100%);
      }
      .pcstatus3 {
        background: linear-gradient(46deg, #fdffff 0%, #e8e8e8 100%);
      }
    }
    .card1-2 {
      width: 100%;
    }
    .m-head {
      .title {
        font-weight: 500;
        font-size: 22px;
        color: #283e62;
        margin-bottom: 20px;
      }
      .CloseBold {
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
        font-size: 22px;
      }
    }
  }
}
.reset-btn {
  width: 60px;
  text-align: center;
  margin-left: 10px;
  height: 20px;
  background: #ffffff;
  border-radius: 19px 19px 19px 19px;
  border: 1px solid #4595fe;
  font-size: 11px;
  color: #4595fe;
  cursor: pointer;
}
</style>
